module.exports = __webpack_public_path__ + "assets/df236c9cc7210f3d62f965b790727aba.png";